import styled from 'styled-components';
import Accordion from '@mui/material/Accordion';

export const ValidationAccordionWrapper = styled(Accordion)`
margin-bottom:70px;
border: 1px solid #1b4a83;
border-radius: 5px;
.accordian{

        background-color: #900916;
        color: rgb(255, 255, 255);
        border-radius: 5px;
        p{
            font-size: 14px;
            font-weight: 600;
        }
span{
    font-size: 14px;
    padding: 1px 15px;
    font-weight: 300;
}
svg{
    color: #fff;
    font-size: 30px;

}

}
.content
{
    margin:30px;
    text-align: left;
    font-size: 14px;
    h6{
        color: #1B4A83;
        font-size: 14px;
        margin:3px;
    }
    span{
        color: #1B4A83;
    }
}
table{

border: 1px solid #1b4a83;
border-radius: 5px;

thead{
    background-color: #1B4A83;
    tr{
        th{
            color: #fff;
            font-weight: 600;
        }
    }
 }
}
.error
{
    color: red;
    font-size:14px;
}
.confirm
{
    color: #03715B;
    font-size:14px;
    font-weight:600;
}
.customDropdown{
    width: 80%;
    margin-top: 12px;
    .css-11u53oe-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input.MuiSelect-select{
        height: 0.4375rem;
        min-height: auto;
    }
    .css-1yk1gt9-MuiInputBase-root-MuiOutlinedInput-root-MuiSelect-root{
        line-height: 0.5;
    }
}
.confirmation
{
    font-size:14px;
    font-weight:600;    
    width:60%;
        justify-content: space-between;
        align-items: center;
}
button{
    margin-top:10px;
    background-color: #03715B;
    font-family: 'Noto Sans', sans-serif;
}
`;